module.exports = __webpack_public_path__ + "static/media/token-preview-fireball.424140db.png";